import type { Player, PlayerPosition } from '@api-service/players';

export type TeamMember = {
  playerId: number;
  player: Player | null;
};

export const POSITION_BY_ID: Record<number, PlayerPosition> = {
  1: 'GK',
  2: 'DEF',
  3: 'MID',
  4: 'FWD'
};
